module.exports = __webpack_public_path__ + "static/media/crawlspace@2x.f7fd2270.jpg";